import axios from 'axios';
import { AppUser } from '../../views/App/App';
import { ALL_LIMIT } from '../../consts/table';

export function getSchoolDetailsChangeLogs(user: AppUser, schoolId: string, filter) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter,
    },
  };

  return axios.get(`${window.apiBase}/admin/schools/${schoolId}/changeLogs`, config).then(response => {
    return response.data;
  });
}

export function getAllSchoolDetailsChangeLogs(user: AppUser, schoolId: string, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where,
          },
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  }

  return axios.get(`${window.apiBase}/admin/schools/${schoolId}/changeLogs`, config).then(response => {
    return response.data;
  });
}

export function getSchoolDetailsChangeLogsCount(user: AppUser, schoolId: string, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
    };
  }

  return axios.get(`${window.apiBase}/admin/schools/${schoolId}/changeLogs/count`, config).then(response => {
    return response.data;
  });
}
